import { ViewOption } from "types/viewOptions";
import AdListSorter from "./AdListSorter";
import AdListViewSelector from "./AdListViewSelector";
import { SortingOptions } from "types/sortingOptions";
import { AdListing } from "types/adListing";
import './AdList.css';

interface AdListHeaderProps {
    sortedIlanlar: AdListing[];
    totalMatchingCount: number;
    itemsPerPage: number;
    currentPage: number;
    totalPages: number;
    sortOption: SortingOptions;
    viewType: ViewOption;
    handleSortChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    onViewChange: (view: ViewOption) => void;
    /** Optional content at the start (e.g. mobile filter button) */
    leftAddon?: React.ReactNode;
}

export default function AdListHeader({
    sortedIlanlar,
    totalMatchingCount,
    itemsPerPage,
    currentPage,
    totalPages,
    sortOption,
    viewType,
    handleSortChange,
    onViewChange,
    leftAddon }: AdListHeaderProps) {
    return (
        <div className="sb-panel sb-list-toolbar">
            <div className="sb-list-toolbar__summary">
                {leftAddon}
                <span className="sb-list-toolbar__count">
                    <strong>{totalMatchingCount}</strong> ilan bulundu
                    {totalPages > 1 && (
                        <span className="sb-list-toolbar__page">
                            {' '}
                            (Sayfa {currentPage} / {totalPages})
                        </span>
                    )}
                </span>
            </div>
            <div className="sb-list-toolbar__controls">
                <AdListViewSelector viewType={viewType} onViewChange={onViewChange} />
                <AdListSorter sortOption={sortOption} handleSortChange={handleSortChange} />
            </div>
        </div>
    )
}
